import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	listApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testcase/ls", params, successCallback, failCallback, exceptionCallback);
	},
	saveApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/tst/testcase/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdateApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testcase/toupdate", params, successCallback, failCallback, exceptionCallback);
	},
	updateApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/tst/testcase/update", params, successCallback, failCallback, exceptionCallback);
	},	mergeApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/tst/testcase/merge", params, successCallback, failCallback, exceptionCallback);
	},
	removeApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/tst/testcase/rmv", params, successCallback, failCallback, exceptionCallback);
	},
	getspringbynameApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testcase/getspringbyname", params, successCallback, failCallback, exceptionCallback);
	},
	getproductidApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testcase/getproductid", params, successCallback, failCallback, exceptionCallback);
	},
	listPublishersApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/tst/testplan/list_publishers", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
